import React from 'react';
import { Button } from '@trevor/ui-components';
import flex from '../css/module/flex.css';
import elements from '../css/module/elements.css';
import cssNewWorld from '../css/module/new-world.css';
import { DASHBOARD_SAVE_BAR } from '../constants/test-ids';

export type SaveBarProps = {
  onSave: F<React.MouseEvent>;
  onCancel: F<React.MouseEvent>;
  saveId: string;
  className?: string;
  isSaving?: boolean;
};
const SaveBar: React.FC<SaveBarProps> = ({
  onSave,
  onCancel,
  saveId,
  className = '',
  isSaving = false,
  children,
}) => (
  <div
    data-testid={DASHBOARD_SAVE_BAR}
    className={`${elements.saveBar} ${cssNewWorld.hiddenDuringPrint} ${className}`}
  >
    <div
      className={`h-100 position-relative ${flex.alignItemsCenter}`}
      style={{ padding: '10px' }}
    >
      <Button
        variant="secondary"
        style={{ marginRight: '8px' }}
        onClick={onCancel}
        disabled={isSaving}
      >
        Discard changes
      </Button>
      <Button disabled={isSaving} onClick={onSave} id={saveId || 'save-button'}>
        {isSaving ? 'Saving changes' : 'Save changes'}
      </Button>
      {children}
    </div>
  </div>
);

export default SaveBar;
